import { Vue, Prop } from 'vue-property-decorator'
import { TriggerData } from "./../types/types";

export class TriggerControlsMixin extends Vue {
  @Prop({ 'type': Object, 'required': true }) readonly triggerData!: TriggerData

  @Prop({ 'type': Boolean, 'required': true }) readonly isTriggerValid!: boolean
}
